/* Katha · currency converter. Rewrites "Rp 1.234.000" on the page into a reference currency.
   Checkout always charges in Indonesian rupiah; this only helps shoppers in SG, MY, TH, AU, US and EU read prices. */
(function () {
  'use strict';
  var KEY = 'kh_cur', RKEY = 'kh_cur_rates', TTL = 12 * 3600 * 1000;
  var CUR = { IDR: ['Rp ', 'Indonesian rupiah'], SGD: ['S$', 'Singapore dollar'], MYR: ['RM ', 'Malaysian ringgit'], THB: ['฿', 'Thai baht'], USD: ['US$', 'US dollar'], AUD: ['A$', 'Australian dollar'], EUR: ['€', 'Euro'] };
  /* fallback rates (IDR → unit), only used when the live rate service is unreachable */
  var FALLBACK = { SGD: 1 / 12300, MYR: 1 / 3800, THB: 1 / 490, USD: 1 / 16300, AUD: 1 / 10800, EUR: 1 / 17600 };
  var RE = /Rp[\s ]?(\d{1,3}(?:\.\d{3})+|\d+)(?!\d|\.\d)/g; /* a full stop after the amount ends the sentence */
  var rates = null, cur = 'IDR', observing = false;

  function store(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }

  function guess() {
    var tz = ''; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    if (/Singapore/.test(tz)) return 'SGD';
    if (/Kuala_Lumpur|Kuching/.test(tz)) return 'MYR';
    if (/Bangkok/.test(tz)) return 'THB';
    if (/^Australia\//.test(tz)) return 'AUD';
    if (/^America\//.test(tz)) return 'USD';
    if (/^Europe\//.test(tz)) return 'EUR';
    return 'IDR';
  }

  function fmtForeign(code, idr) {
    var v = idr * rates[code], d = v < 20 ? 2 : 0;
    var n = v.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return CUR[code][0] + n;
  }
  function fmtIdr(n) { return 'Rp ' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, TITLE: 1 };
  function skip(el) {
    for (var e = el; e && e.nodeType === 1; e = e.parentNode) {
      if (SKIP[e.tagName] || e.hasAttribute('data-kh-cur') || e.classList.contains('kh-cur-x') || e.hasAttribute('data-kh-cur-skip')) return true;
    }
    return false;
  }

  /* IDR → foreign: wrap each match in a span that remembers the rupiah amount */
  function convertText(node) {
    var t = node.nodeValue; if (!t || t.indexOf('Rp') < 0) return;
    RE.lastIndex = 0; if (!RE.test(t)) return;
    RE.lastIndex = 0;
    var frag = document.createDocumentFragment(), last = 0, m;
    while ((m = RE.exec(t))) {
      if (m.index > last) frag.appendChild(document.createTextNode(t.slice(last, m.index)));
      var idr = parseInt(m[1].replace(/\./g, ''), 10);
      /* inside an SVG drawing an HTML span is not drawn: use an SVG tspan there */
      var svg = node.parentNode && node.parentNode.namespaceURI === 'http://www.w3.org/2000/svg';
      var s = svg ? document.createElementNS('http://www.w3.org/2000/svg', 'tspan') : document.createElement('span');
      s.setAttribute('class', 'kh-cur-x'); s.setAttribute('data-idr', idr); if (!svg) s.title = '≈ ' + fmtIdr(idr);
      s.textContent = fmtForeign(cur, idr); frag.appendChild(s); last = m.index + m[0].length;
    }
    if (last < t.length) frag.appendChild(document.createTextNode(t.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }
  function convertTree(root) {
    if (!root) return;
    if (root.nodeType === 3) { if (!skip(root.parentNode)) convertText(root); return; }
    if (root.nodeType !== 1 || skip(root)) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), list = [], n;
    while ((n = w.nextNode())) if (n.nodeValue.indexOf('Rp') > -1 && !skip(n.parentNode)) list.push(n);
    list.forEach(convertText);
  }
  function restore() {
    [].slice.call(document.querySelectorAll('.kh-cur-x')).forEach(function (s) {
      s.parentNode.replaceChild(document.createTextNode(fmtIdr(s.getAttribute('data-idr'))), s);
    });
    [].slice.call(document.querySelectorAll('*')).forEach(function (el) { if (el.normalize) {} });
  }
  function relabel() {
    [].slice.call(document.querySelectorAll('.kh-cur-x')).forEach(function (s) { s.textContent = fmtForeign(cur, +s.getAttribute('data-idr')); });
  }

  var mo;
  function watch() {
    if (observing || !('MutationObserver' in window)) return;
    mo = new MutationObserver(function (ms) {
      if (cur === 'IDR') return;
      ms.forEach(function (m) {
        if (m.type === 'characterData') { if (!skip(m.target.parentNode)) convertText(m.target); return; }
        [].slice.call(m.addedNodes).forEach(convertTree);
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    observing = true;
  }

  function apply(code, remember) {
    if (!CUR[code]) code = 'IDR';
    if (code !== 'IDR' && !rates) return;
    var was = cur; cur = code;
    if (remember) store(KEY, code);
    if (code === 'IDR') restore();
    else if (was === 'IDR') { convertTree(document.body); watch(); }
    else relabel();
    [].slice.call(document.querySelectorAll('[data-kh-cur-label]')).forEach(function (l) { l.textContent = code; });
    [].slice.call(document.querySelectorAll('[data-kh-cur-pick]')).forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-kh-cur-pick') === code)); });
  }

  function withRates(cb) {
    var c = load(RKEY);
    if (c && c.t && Date.now() - c.t < TTL && c.r) { rates = c.r; return cb(); }
    var done = false;
    function fin(r) { if (done) return; done = true; rates = r; cb(); }
    try {
      fetch('https://open.er-api.com/v6/latest/IDR').then(function (r) { return r.json(); }).then(function (j) {
        if (j && j.rates) { var r = {}; Object.keys(FALLBACK).forEach(function (k) { r[k] = j.rates[k] || FALLBACK[k]; }); store(RKEY, { t: Date.now(), r: r }); fin(r); }
        else fin(FALLBACK);
      }).catch(function () { fin(FALLBACK); });
      setTimeout(function () { fin(FALLBACK); }, 4000);
    } catch (e) { fin(FALLBACK); }
  }

  function wire() {
    [].slice.call(document.querySelectorAll('[data-kh-cur]')).forEach(function (box) {
      var btn = box.querySelector('[data-kh-cur-btn]'), menu = box.querySelector('[data-kh-cur-menu]');
      if (!btn || !menu) return;
      function open(o) { menu.hidden = !o; btn.setAttribute('aria-expanded', String(o)); if (o) box.setAttribute('open', ''); else box.removeAttribute('open'); }
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(menu.hidden); });
      menu.addEventListener('click', function (e) {
        var b = e.target.closest('[data-kh-cur-pick]'); if (!b) return;
        open(false); withRates(function () { apply(b.getAttribute('data-kh-cur-pick'), true); });
      });
      document.addEventListener('click', function (e) { if (!box.contains(e.target)) open(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    });
  }

  function init() {
    wire();
    var saved = load(KEY), code = saved || guess();
    if (code === 'IDR') { apply('IDR', !!saved); return; }
    withRates(function () { apply(code, false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
